import React from 'react';
import Dropzone from 'react-dropzone';
import { ProgressBar, Button } from 'react-bootstrap';
import axios from './../../../../../constants/axios';

class ProductSubEditImage extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         loading: false,
         files: [],
         progress: 0,
         currentImages: []
      };
   }

   componentDidMount = () => {
      this.loadFiles();
   };

   loadFiles = () => {
      const { productId } = this.props.params;
      axios.get('items/productSub/getImagesById/' + productId)
         .then((res) => {
            this.setState({
               currentImages: res.data,
            });
         });
   };

   onDrop = (files) => {
      this.setState({
         files: files
      });
   };

   uploadFiles = () => {
      let body = new FormData();
      let { files } = this.state;
      Object.keys(files).forEach((key) => {
         body.append(key, files[key]);
      });
      let config = {
         onUploadProgress: (progressEvent) => {
            let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            this.setState({
               progress: percentCompleted,
            });
         }
      };
      this.setState({
         loading: true,
      });
      const { productId } = this.props.params;
      axios.post('items/productSub/addProductImage/' + productId, body, config)
         .then(() => {
            this.setState({
               loading: false,
               progress: 0,
               files: []
            });
            this.loadFiles();
         });
   };

   deleteProductImage = (imageId) => {
      this.setState({
         loading: true,
      });
      axios.delete('items/productSub/deleteProductImage/' + imageId)
         .then(() => {
            this.setState({
               loading: false,
            });
            this.loadFiles();
         });
   };

   defaultProductImage = (productId, imageId) => {
      this.setState({
         loading: true,
      });
      axios.put('items/productSub/defaultProductImage/' + productId + '/' + imageId)
         .then(() => {
            this.setState({
               loading: false,
            });
            this.loadFiles();
         });
   };

   render() {
      const { files, currentImages, progress, loading } = this.state;
      return (
         <div>
            <Dropzone onDrop={this.onDrop} >
               <div>Try dropping some files here, or click to select files to upload.</div>
            </Dropzone>
            {files ? <div>
               <h2>Uploading {files.length} files...</h2>
               <div>{files.map((file, idx) => <img key={idx} width={200} height={200} src={file.preview} />)}</div>
            </div> : null}
            <ProgressBar striped bsStyle="success" now={progress} />
            <Button disabled={loading || files.length <= 0} onClick={this.uploadFiles} >
               {loading ? 'Uploading...' : 'Upload Files'}
            </Button>
            <hr/>
            <h5>Current images</h5>
            <div>
               {
                  currentImages &&
                  currentImages.map((img) =>
                     <div key={img.id} style={{ margin: '4px', display: 'inline-block' }} >
                        <img style={{ display: 'block' }} src={`/img/products/${img.image_url}`} alt="" width="100"
                             height="100" />
                        {!img.default &&
                        <Button bsSize="xsmall" disabled={loading} bsStyle="success"
                                onClick={() => this.defaultProductImage(img.item_id, img.id)} >set default</Button> }
                        <Button bsSize="xsmall" disabled={loading} onClick={() => this.deleteProductImage(img.id)}
                                bsStyle="danger" >delete</Button>
                     </div>
                  )
               }
            </div>
         </div>
      );
   }
}

ProductSubEditImage.propTypes = {
   params: React.PropTypes.object,
};

export default ProductSubEditImage;



/** WEBPACK FOOTER **
 ** ./src/components/ItemManagement/Product/ProductSub/ProductSubEdit/ProductSubEditImage.js
 **/